import firebase from 'firebase/app';
import "firebase/auth";
import axios from 'axios';

class AuthService {
    _API_URL = process.env.VUE_APP_API_URL;

    login = (email, password) => {
        return firebase.auth().signInWithEmailAndPassword(email, password);
    }

    signup = (email, password, firstName, lastName) => {
        const body = {
            email,
            password,
            firstName,
            lastName
        };

        return axios.post(`${this.apiUrl}/sendMail`, body);
    }

    forgotPassword = (email) => {
        return firebase.auth().sendPasswordResetEmail(email);
    }

    get apiUrl() {
        return this._API_URL;
    }
}

export default new AuthService();



// WEBPACK FOOTER //
// ./src/services/auth.js